import { FormType } from '@Components/MainForm/types';

export const getEditFormType = (isOpenStatus: boolean): FormType => {
  const formType = isOpenStatus ? 'edit' : 'edit-submitted';
  return formType;
};
